// extracted by mini-css-extract-plugin
export default {"flowCorrelationRed":"FlowCorrelation_flowCorrelationRed__h-8bh","flowCorrelationGreen":"FlowCorrelation_flowCorrelationGreen__FH3zO","title":"FlowCorrelation_title__9ELPj"};